import { ChainID } from './types';

export const ENABLED_SECRET_NETWORK_IDS = [
  'scrt-cosmos-grpc-web',
  'scrt-cosmos-rest',
  'scrt-rest',
];

export const ENABLED_ZETACHAIN_IDS = [
  'zetachain-tendermint-rest-testnet',
  'zetachain-cosmos-rest-testnet',
  'zetachain-tendermint-rest-athens-testnet',
  'zetachain-cosmos-rest-athens-testnet',
];

export const ENABLED_KAVA_IDS = [
  'kava-tendermint-rest',
  'kava-tendermint-rest-testnet',
  'kava-cosmos-rest',
  'kava-cosmos-rest-testnet',
];

// TAC ids which have different public and private endpoints
export const TAC_IDS = [
  ChainID.TAC_TENDERMINT_REST,
  ChainID.TAC_COSMOS_REST,
  ChainID.TAC_COSMOS_GRPC,
  ChainID.TAC_TESTNET_TURIN_TENDERMINT_REST,
  ChainID.TAC_TESTNET_TURIN_COSMOS_GRPC,
  ChainID.TAC_TESTNET_TURIN_COSMOS_REST,
  ChainID.TAC_TESTNET_SPB_TENDERMINT_REST,
  ChainID.TAC_TESTNET_SPB_COSMOS_GRPC,
  ChainID.TAC_TESTNET_SPB_COSMOS_REST,
];

// Sei ids which have different public and private endpoints
export const SEI_IDS = [
  'sei-cosmos-grpc-web',
  'sei-cosmos-rest',
  'sei-rest',

  'sei-rest-testnet',
  'sei-cosmos-rest-testnet',
  'sei-cosmos-grpc-web-testnet',
];

// Stellar ids which have different public and private endpoints
export const STELLAR_IDS = ['stellar-horizon', 'stellar-testnet-horizon'];

// Movement ids which have different public and private endpoints
export const MOVEMENT_IDS = ['movement_bardock-rest', 'movement_mainnet-rest'];

export const APTOS_IDS = ['aptos', 'aptos_testnet'];

export const KAVA_IDS = [
  'kava-cosmos-rest',
  'kava-cosmos-rest-testnet',
  'kava-evm',
  'kava-evm-testnet',
  'kava-tendermint-rest',
  'kava-tendermint-rest-testnet',
  'kava-tendermint-rpc',
  'kava-tendermint-rpc-testnet',
];

// Allora ids which have different public and private endpoints
export const ALLORA_IDS = ['allora_testnet-rest', 'allora_testnet-cosmos-rest'];
// 0g ids which have different public and private endpoints
export const ZERO_G_IDS = [
  ChainID.ZERO_G_BEACONKIT_REST,
  ChainID.ZERO_G_GALILEO_BEACONKIT_REST,
  ChainID.ZERO_G_GALILEO_TENDERMINT_REST,
];

export const blockchainNameTemplate = '{blockchain}';

export const userNameTemplate = '{user}';
